import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
 selector: 'iho-ecolodge-types',
 standalone: true,
 imports: [CommonModule, RouterModule],
 templateUrl: './ecolodge-types.component.html',
 styleUrls: ['./ecolodge-types.component.scss'],
})
export class EcolodgeTypesComponent {
 @Input() dataSource: any;

 ss = {
  title: 'دیدنی‌ترین مقصدهای ایران',
  items: [
   {
    title: 'ویلا',
    icon: 'Villa.svg',
    link: '',
   },
   {
    title: 'کلبه',
    icon: 'Cottage.svg',
    link: '',
   },
   {
    title: 'بومگردی',
    icon: 'Ecotourism.svg',
    link: '',
   },
   {
    title: 'استخردار',
    icon: 'Pool.svg',
    link: '',
   },
   {
    title: 'ساحلی',
    icon: 'Coastal.svg',
    link: '',
   },
   {
    title: 'آپارتمان',
    icon: 'Apartment.svg',
    link: '',
   },
   {
    title: 'اقتصادی',
    icon: 'Echo.svg',
    link: '',
   },
   {
    title: 'جنگلی',
    icon: 'Forest.svg',
    link: '',
   },
   {
    title: 'کوهستانی',
    icon: 'Mountainous.svg',
    link: '',
   },
   {
    title: 'کوپری',
    icon: 'Desert.svg',
    link: '',
   },
  ],
 };

 clickOnType(e: Event) {
  e.preventDefault();
 }
}
